var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37502 15C2.87925 15 1.66669 13.7874 1.66669 12.2917V5.20833C1.66669 3.71256 2.87925 2.5 4.37502 2.5H15.625C17.1208 2.5 18.3334 3.71256 18.3334 5.20833V12.2917C18.3334 13.7874 17.1208 15 15.625 15H10.8438L6.66559 18.1256C6.2049 18.4701 5.5521 18.376 5.20753 17.9153C5.07282 17.7352 5.00002 17.5163 5.00002 17.2916L4.99937 15H4.37502ZM10.4279 13.75H15.625C16.4304 13.75 17.0834 13.0971 17.0834 12.2917V5.20833C17.0834 4.40292 16.4304 3.75 15.625 3.75H4.37502C3.56961 3.75 2.91669 4.40292 2.91669 5.20833V12.2917C2.91669 13.0971 3.56961 13.75 4.37502 13.75H6.24901L6.24919 14.3748L6.2499 16.8755L10.4279 13.75Z",
    fill: "#9B9DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.38295abf9e482ee40b180fc465a33149.svg";
export { ForwardRef as ReactComponent };